import React from 'react';

// Components
import PrimaryButton from './PrimaryButton';
import { ButtonProps } from 'react-bootstrap';

type Props = {
  ariaLabel?: string;
  children?: JSX.Element | JSX.Element[];
  className?: string;
  onClick: (...args: any[]) => void;
} & ButtonProps;

/**
 * Why would we need an invisible button component? For accessibility!
 * We need to wrap any clickable element in a button tag.
 *
 * This component is used to wrap elements that
 * should be clickable but don't have the button style.
 */
const InvisibleButton = React.forwardRef<HTMLButtonElement, Props>(({ ariaLabel, children, className = '', onClick, ...buttonProps }, ref) => (
  <PrimaryButton ref={ref} onClick={onClick} aria-label={ariaLabel} className={`invisible-button ${className}`} {...buttonProps}>
    <div className="button-content">{children}</div>
  </PrimaryButton>
));

InvisibleButton.displayName = 'InvisibleButton';

export default InvisibleButton;
